import { Alert } from 'shared/mui/Alert/Alert';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import { formatRangeInputInTz } from 'utils/date';
import { getUTCOffsetString } from 'utils/getUTCOffsetString';

type ExpenseReportListSuccessAlertProps = {
  dateFrom: number;
  dateTo: number;
  currency: string;
};

export const ExpenseReportListSuccessAlert = ({
  dateFrom,
  dateTo,
  currency,
}: ExpenseReportListSuccessAlertProps) => {
  return (
    <Alert severity="success">
      {`Отчёт сформирован за период ${formatRangeInputInTz([dateFrom, dateTo], {
        format: 'dd.MM.yyyy',
      })} (${getUTCOffsetString(DEFAULT_TIMEZONE)}) и сконвертирован в выбранной валюте ${currency} по историческому курсу.`}
    </Alert>
  );
};
